export default __webpack_public_path__ + "static/media/190629_190332_IMG_4110.5dbb4363.jpg";